var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74001 0.867804C7.98346 0.884033 8.16199 0.997642 8.27559 1.20863L9.93103 4.64121L13.6557 5.17679C13.8992 5.22548 14.0615 5.36343 14.1426 5.59065C14.2076 5.81787 14.1589 6.01262 13.9966 6.17492L11.2943 8.85282L11.9273 12.6506C11.9597 12.8778 11.8786 13.0725 11.6838 13.2348C11.4891 13.3647 11.2862 13.3728 11.0752 13.2592L7.74001 11.482L4.40481 13.2592C4.19382 13.3728 3.99095 13.3566 3.79619 13.2105C3.60144 13.0644 3.52029 12.8778 3.55275 12.6506L4.18571 8.85282L1.48346 6.17492C1.32116 6.01262 1.27247 5.81787 1.33739 5.59065C1.41854 5.36343 1.58084 5.22548 1.82428 5.17679L5.549 4.64121L7.20443 1.20863C7.31804 0.997642 7.49657 0.884033 7.74001 0.867804ZM7.74001 2.79102L6.44975 5.42024C6.3686 5.59876 6.22254 5.71237 6.01155 5.76106L3.13889 6.17492L5.23252 8.24421C5.36236 8.39028 5.41917 8.56069 5.40294 8.75544L4.8917 11.6768L7.47222 10.3135C7.65075 10.2161 7.82928 10.2161 8.0078 10.3135L10.564 11.6768L10.0771 8.75544C10.0446 8.56069 10.1014 8.39028 10.2475 8.24421L12.3411 6.17492L9.46848 5.76106C9.25749 5.71237 9.11142 5.59876 9.03028 5.42024L7.74001 2.79102Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.14,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.669922 13.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.405ba8959657ad212da490e3298d374d.svg";
export { ForwardRef as ReactComponent };